import { styled } from '@tools/wr-catalog-base'
import { ProductTypeLabel } from './ProductBody/styles'

export const DecisionTreeContainer = styled.div`
  .decision-tree-header {
    border-bottom: 1px solid #ddd;
  }

  .decision-tree-footer {
    border-top: 1px solid #ddd;
  }

  input,
  textarea,
  .react-date-picker__wrapper {
    border-radius: 5px;
  }

  .react-date-picker__wrapper {
    color: #333;
  }

  .react-date-picker__calendar-button svg {
    fill: #333;
  }
`

export const StyledList = styled.div`
  [class^='toolbar__'] input:focus {
    border-color: #ced4da;
    box-shadow: none;
    outline: none;
  }

  .split-view {
    @media only screen and (min-width: 992px) {
      width: 100%;

      .container {
        width: 100%;
      }
    }

    @media only screen and (min-width: 1200px) {
      width: 1285px;

      .container {
        width: 100%;
      }

      .row.start-xs > div {
        padding: 0 1rem;
      }
    }
  }

  .split-view-switcher {
    border-bottom: 1px solid #0477a8;
  }

  .product-list-price-duration {
    display: flex;
    justify-content: flex-end;
    text-align: right;
    min-height: 15px;
    font-size: 0.9em;
    margin-top: 12px;
  }

  .product-name {
    font-size: 1.2em;
    line-height: 1.4em;
    font-weight: 600;
  }

  .split-view-switcher li {
    border: none;
    background-color: transparent;
    color: #333;
  }

  .split-view-switcher li:first-child {
    border-right: none;
  }

  .split-view-switcher li.active {
    border-bottom: 3px solid #0477a8;
    background-color: transparent;
    color: #0477a8;
  }

  .products-container .row > div {
    margin-top: 2.6rem;
  }

  .products-container button {
    width: 100%;
    border-radius: 5px;
    padding: 12px;
  }

  .product-description {
    max-height: 200px;
    overflow-y: scroll;
    padding-bottom: 0;
  }

  .title {
    margin: 50px 0 20px;
    text-align: center;
    font-size: 25px;
    color: #0477a8;
  }

  .categories-container {
    button {
      padding: 0.25rem 0.5rem;
      line-height: 1.5;
    }
  }

  .filters__menu {
    width: 350px;
  }
`

export const SubTitle = styled.p`
  line-height: 22px;
  margin-bottom: 40px;
`

export const RegionalFilterMessage = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
  text-align: center;
  font-weight: bold;
`

export const FeaturedItemsHeader = styled.h3`
  color: white;
  background-color: var(--color-green);
  display: inline-block;
  padding: 5px 10px 0px;
  font-family: 'CenturyGothic';
  box-shadow: 0px 5px 5px #0008;
`

export const FeaturedItemCard = styled.a`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 150px;
  padding: 10px 20px 0;
  // Leave room for the overhanging icon and button
  margin: 30px 0 20px;
  background: #fcfcfc;
  color: rgb(51, 51, 51);
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease-in-out;
  border: 3px solid #3d4647;
  box-shadow: 4px 3px 0 0.4px #798283;
  border-radius: 20px;

  &:hover {
    background-color: #3d4647;
    box-shadow: 0 0 5px 3px var(--color-green);
    color: #fff;
  }

  &:hover path {
    fill: #fff;
  }

  & .product-name {
    display: block;
    max-width: 280px;
    margin-left: auto;
    font-size: 1.2em;
    line-height: 1.4em;
    font-weight: 600;
    text-align: right;
  }

  & .featured-card-icon {
    position: absolute;
    z-index: 2;
    top: 20px;
    left: 25px;
    border-radius: 50%;

    svg {
      transform: scale(1.4);
    }
  }

  .featured-card-icon.vrd {
    top: 8.5px;
    left: 0;

    svg {
      transform: scale(0.91);
    }
  }

  .learn-more {
    background: var(--color-blue);
    // Copied from Link
    padding: 0.4rem 1rem;
    font-size: 0.8em;
    transform: translateY(50%);
    width: auto;
    margin-left: auto;
  }
`

export const ProductBadgeContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
`

export const ProductBadge = styled.div`
  transform: rotate(-45deg);
  transform-origin: top left;
  background-color: #3d4647;
  color: white;
  padding: 5px 35px;
  font-weight: bold;
  white-space: nowrap;
  margin-top: 60px;
  margin-left: -40px;

  transition: 0.3s ease-in color, 0.3s ease-out background-color;

  position: absolute;
  top: 12px;
  left: 13px;
  pointer-events: none;

  ${({ isFeatured }) =>
    isFeatured &&
    `
    font-size: 14px;  
    z-index: 3;
  `}
`

export const ProductListWrapper = styled.div`
  div > .wr__card-container {
    filter: var(--color-hover-filter);
  }

  .wr__card-container {
    justify-content: space-between;
    padding: 10px 20px 0;
    border: 3px solid #3d4647;
    box-shadow: 4px 3px 0 0.4px #798283;
    border-radius: 20px;

    min-height 200px;
    max-height: 200px;

    @media (min-width: 575px) and (max-width: 1100px) {
      min-height: 230px;
      max-height: 230px;
    }

    &:hover path {
      fill: #fff;
    }

    & path {
      transition: fill 0.285s ease-in-out;
    }

    & .product-card-icon {
      position: relative;
      z-index: 2;
      top: 8px;
      left: 0;
      border-radius: 50%;

      svg {
        transform: scale(1.4);
      }
    }

    & .product-card-icon.vrd {
      top: 0;
      left: -10px;

      & svg {
        transform: scale(0.91);
      }
    }

    & .product-card-icon.adoptionpackage {
      top: 0;
      left: -10px;

      & svg {
        transform: scale(0.9);
      }
    }

    &:hover {
      background-color: #3d4647;

      & ${ProductTypeLabel} {
        visibility: hidden;
      }

      & ${ProductBadge} {
        background-color: #fff;
        color: #3d4647;
      }
    }

    & .product-name {
      display: block;
      max-width: 280px;
      margin-left: auto;

      & a {
        display: block !important;
        transition: color 0.3s ease-in-out;
        text-align: right !important;
        color: rgb(51, 51, 51);
      }
    }

    & button a {
      color: rgb(51, 51, 51);
    }

    .product-description {
      flex: 0;
      width: 100%;
      padding: 0;
      text-align: center;
      overflow: visible;
      position: static;

      margin-top: auto;
      margin-bottom: 36px;

      p {
        visibility: hidden;
        overflow: hidden;
      }

      .learn-more {
        visibility: hidden;
      }
    }

    .wr__product-header {
      padding: 0;
      text-align: center;
      background: none;
      max-height: max-content;

      a {
        font-size: 19px;
        font-weight: 600;
        padding: 0;
        margin: 0 0 0 15px;
      }

      & > div {
        opacity: 1;
        pointer-events: auto;
        z-index: 3;
        right: -25px;
        top: -6px;
        display: block;

        button {
          position: relative;
          display: inline-block;
          color: #fff;
          white-space: nowrap;
          text-align: center;
          background: green;
          text-decoration: none;
          border-color: hsla(0, 0%, 100%, 0.75);
          border-radius: 3px;
          font-size: 11px;
          padding: 5px 12px 5px 10px !important;
          font-weight: 300;
          -webkit-transition: background 0.2s ease;
          transition: background 0.2s ease;
          cursor: pointer;
          z-index: 99999;
        }
      }
    }

    button {
      width: auto;
      padding: 9px;
      background-color: #3d4647;
      border: 0;
      border-radius: 0;
      font-size: 13px;
      color: #ffffff;
      transform: translateY(50%);
      position: absolute;
      bottom: 0px;
      right: 13px;
    }

    &:hover {
      justify-content: flex-start;
      align-items: space-between;

      .wr__product-header {
        .product-name a {
          color: #fff !important;
          transition-animation: ease-in;
          transition-duration: 0.2s;
        }
      }

      & * {
        color: #fff;
        fill: #fff;
      }

      .product-description {
        p,
        .learn-more {
          visibility: visible;
        }
      }
    }
  }
`
